export default (instance) => {
  return {
    getLeads({ domain, page = 1, qs = '', _id }) {
      return instance.get(`${domain}/${_id}?page=${page}&${qs}`)
        .then(r => r.data)
    },
    getAccount({ domain, _id }) {
      return instance.get(`${domain}/${_id}/info`)
        .then(r => r.data)
    },
    sendFeedback({ leadName, name, phone, domain, comment, _id }) {
      return instance.post(`${domain}/feedback/add/${_id}`, {
        name,
        phone,
        comment,
        leadName
      })
    }
  }
}
